import { HttpErrorResponse } from '@angular/common/http';
import { EventEmitter, inject, Injectable } from '@angular/core';
import { ConfigLoader } from '../engine/config/config-loader';
import { AuthorizationService } from '../auth/authorization.service';
import { NameValue } from '../tool/name-value';
import { SettingsService } from '../interface/settings-service';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { AppConfig } from '../engine/app-config';
import { RestService } from '../engine/http/rest.service';
import { ChangelogService } from './changelog.service';

@Injectable({
  providedIn: 'root',
})
export class InitService {
  protected configLoader = inject(ConfigLoader);
  protected auth = inject(AuthorizationService);
  protected rest = inject(RestService);
  protected settings = inject(SettingsService);
  protected router = inject(Router);
  protected changelogService = inject(ChangelogService);

  get isLoaded(): boolean {
    return this._isLoaded;
  }

  set isLoaded(value: boolean) {
    this._isLoaded = value;
    this._isLoaded$.next(value);
  }

  get isLoaded$(): Observable<boolean> {
    return this._isLoaded$.asObservable();
  }

  protected _isLoaded = false;
  protected _isLoaded$ = new BehaviorSubject<boolean>(false);
  public isConfigLoaded = new BehaviorSubject<boolean>(false);

  protected obs = new EventEmitter<NameValue>();
  protected config: AppConfig;

  constructor() {
    this.listenAuth();
    this.listenSettings();
  }

  public init(configName?: string) {
    this.configLoader.load(configName).subscribe((config) => {
      // if (
      //   config.maintenance.maintenanceMode &&
      //   !sessionStorage.getItem('bypassMaintenance')
      // ) {
      //   this.obs.next(new NameValue('maintenance', null));
      //   this.router.navigateByUrl(config.maintenance.route).then();
      //   return;
      // }

      if (config.loginConfig) {
        this.config = config;
        this.isConfigLoaded.next(true);
        this.obs.next(new NameValue('config', config));
        // this.auth.init();
      } else {
        this.loadSettings();
      }
    });
  }

  protected loadSettings() {
    this.settings.load(true);
  }

  public subscribe(
    next: (NameValue) => void,
    error?: (any) => void,
  ): Subscription {
    return this.obs.subscribe(next, error);
  }

  protected listenAuth() {
    this.auth.subscribe(
      (value: NameValue) => {
        if (value.name === 'login') {
          this.obs.next(new NameValue('login', this.auth.user));
          this.loadSettings();
        }
        if (value.name === 'logout') {
          this.obs.next(new NameValue('logout', null));
          this.isLoaded = false;
        }
        if (value.name === 'portal-action' && value.value) {
          this.isLoaded = true;
          this.obs.next(value);
        }
      },
      (error: any) => {
        this.obs.error(error);
      },
    );
  }

  protected listenSettings() {
    this.settings.subscribe(
      () => {
        this.checkApps();
        this.initChangelog();
      },
      (error) => {
        if (error instanceof HttpErrorResponse) {
          this.checkSettingsError(error);
        }
      },
    );
  }

  protected checkSettingsError(error: HttpErrorResponse) {
    this.obs.error(error);
    if (error.status === 401) {
      this.auth.logout();
    } else {
      this.router.navigateByUrl(`error/${error.status}`).then();
    }
  }

  protected checkApps() {
    this.obs.next(new NameValue('settings', this.settings));
    if (this.config.loginConfig?.portalConnection?.loadPortalApps) {
      this.auth.generatePortalAction();
    } else {
      this.isLoaded = true;
    }
  }

  protected initChangelog() {
    if (this.config.changelog.enable) {
      this.changelogService.init();
      this.obs.next(new NameValue('changelog', null));
    }
  }
}
